import { useDocumentType } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.hooks';
import { Purchase } from '@/core/domain/purchase/Purchase.types';
import useValidateRoutes from '@/hooks/useValidateRoutes';
import { RouteType } from '@/types/RouteType';
import { Status } from '@/utils/enum/statusEnum';

const purchaseValidationTabs = (route: RouteType, purchase?: Purchase) => {
  const { data } = useDocumentType(purchase?.documentTypeId);

  let routeValidate = useValidateRoutes({
    route: route.parent,
    validation:
      purchase?.situation === Status.open ||
      purchase?.situation === Status.canceled ||
      data?.notGenerateFinancial,
    keys: ['purchaseFinancial'],
  });

  if (!purchase?.isGrouping) {
    routeValidate = {
      ...routeValidate,
      routes: routeValidate.routes.filter(
        (route) => route.key !== 'purchaseGroupings',
      ),
    };
  }

  if (purchase?.freightInvoice) {
    routeValidate = {
      ...routeValidate,
      routes: routeValidate.routes.filter(
        (route) => route.key !== 'itemsPurchase',
      ),
    };
  } else {
    routeValidate = {
      ...routeValidate,
      routes: routeValidate.routes.filter(
        (route) => route.key !== 'dataFreigth',
      ),
    };
  }

  return routeValidate;
};

export default purchaseValidationTabs;
